import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown, FaChevronUp, FaCommentAlt } from "react-icons/fa";

const cateringOffers = [
    {
        id: 1,
        gole: "Buffet Lunch",
        description: "Enjoy unlimited buffet with 20% off!",
        couponCode: "BUFFET20",
        startDate: "2025-09-01",
        endDate: "2025-09-30",
        discountPercentage: 20,
        offerType: "buffet",
    },
    {
        id: 2,
        gole: "Wedding Package",
        description: "Flat 15% off on wedding catering bookings.",
        couponCode: "WED15",
        startDate: "2025-09-10",
        endDate: "2025-12-31",
        discountPercentage: 15,
        offerType: "wedding",
    },
    {
        id: 3,
        gole: "Birthday Special",
        description: "Book birthday catering & get 1kg cake free 🎂",
        couponCode: "BIRTHDAYFREE",
        startDate: "2025-09-05",
        endDate: "2025-11-30",
        discountPercentage: 10,
        offerType: "birthday",
    },
    {
        id: 4,
        gole: "Corporate Lunch",
        description: "Get 25% off on corporate lunch packages.",
        couponCode: "CORP25",
        startDate: "2025-09-01",
        endDate: "2025-10-31",
        discountPercentage: 25,
        offerType: "corporate",
    },
];

const Cateringascrolling = () => {
    const [vendorId, setVendorId] = useState(null);
    const isMobile = window.innerWidth <= 768;

    const [isOpen, setIsOpen] = useState(false);
    const [ticketType, setTicketType] = useState("");
    const [message, setMessage] = useState("");
    const [attachment, setAttachment] = useState("");

    const [isPaused, setIsPaused] = useState(false);
    const [expandedCard, setExpandedCard] = useState(null);

    const scrollRef = useRef(null);

    // --- Populate vendorId from localStorage ---
    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    // --- Automatic smooth scroll ---
    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;

        let scrollPosition = 0;
        const scrollStep = 1; // pixels per interval
        const intervalTime = 20; // ms

        const scrollInterval = setInterval(() => {
            if (!isPaused) {
                scrollPosition += scrollStep;
                if (scrollPosition >= scrollContainer.scrollHeight - scrollContainer.clientHeight) {
                    scrollPosition = 0; // loop back to top
                }
                scrollContainer.scrollTop = scrollPosition;
            }
        }, intervalTime);

        return () => clearInterval(scrollInterval);
    }, [isPaused]);


    // --- Toggle expand/collapse card ---
    const toggleCard = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };

    // --- Handle image upload for ticket ---
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Data = reader.result.split(",")[1];
                setAttachment(base64Data);
            };
            reader.readAsDataURL(file);
        }
    };

    // --- Send support ticket ---
    const handleSendTicket = async () => {
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Vendor ID or Token not found in localStorage.");
            return;
        }

        if (!ticketType || !message) {
            alert("Please fill all the fields");
            return;
        }

        const payload = {
            vendorId: Number(vendorId),
            ticketType,
            message,
            attachmentUrl: attachment || "",
        };

        try {
            const response = await fetch(
                "https://backend.maamaas.com/food/vendor-tickets/create",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();

            if (response.ok) {
                alert("Ticket submitted successfully!");
                setTicketType("");
                setMessage("");
                setAttachment("");
                setIsOpen(false);
            } else {
                alert(result.message || "Failed to submit ticket.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            alert("Something went wrong while submitting the ticket.");
        }
    };

    const getOfferColor = (type) => {
        switch (type) {
            case "buffet":
                return "#ff6f61";
            case "wedding":
                return "#6a5acd";
            case "birthday":
                return "#ffb347";
            case "corporate":
                return "#2e8b57";
            default:
                return "#333";
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-7 col-md-7 col-sm-12 col-12 subscription-home"></div>

                <div className="col-3">
                    <div
                        style={{
                            position: "fixed",
                            bottom: "62px",
                            right: "16px",
                            top: "40px",
                            height: "560px",
                            borderRadius: "8px",
                            padding: "10px",
                            marginTop: "40px",
                        }}
                        className="scroll-fixed-data mobilescroll"
                        onMouseEnter={() => setIsPaused(true)}
                        onMouseLeave={() => setIsPaused(false)}
                    >
                        {/* Scrollable Offers */}
                        <div
                            style={{
                                position: "fixed",
                                bottom: "62px",
                                right: "16px",
                                top: "40px",
                                height: "560px",
                                borderRadius: "8px",
                                padding: "10px",
                                marginTop: "40px",
                            }}
                            className="scroll-fixed-data mobilescroll"
                        >
                            {/* Scrollable Offers */}
                            <div
                                ref={scrollRef}
                                onMouseEnter={() => setIsPaused(true)}
                                onMouseLeave={() => setIsPaused(false)}
                                style={{
                                    maxHeight: "570px",
                                    overflowY: "auto",
                                    paddingRight: "5px",
                                    scrollbarWidth: "none",
                                    msOverflowStyle: "none",
                                    marginTop: "40px",
                                }}
                                className="hide-scrollbar"
                            >
                                {cateringOffers
                                    .filter((post) => new Date(post.endDate) >= new Date())
                                    .map((post, index) => (
                                        <div
                                            key={post.id}
                                            onClick={() => toggleCard(index)}
                                            className="card"
                                            style={{
                                                width: "300px",
                                                marginBottom: "12px",
                                                background: getOfferColor(post.offerType),
                                                borderRadius: "10px",
                                                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                                cursor: "pointer",
                                                transition: "all 0.3s ease",
                                                padding: "15px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "100%",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <h4 style={{ color: "#fff", marginBottom: "10px" }}>
                                                    {post.gole} Offer 🎉
                                                </h4>
                                                <p style={{ color: "#f5f5f5", fontSize: "15px" }}>
                                                    {post.description}
                                                </p>
                                                <button
                                                    style={{
                                                        marginTop: "10px",
                                                        backgroundColor: "#f5f5f5",
                                                        color: "#000",
                                                        border: "none",
                                                        padding: "6px 16px",
                                                        borderRadius: "6px",
                                                        cursor: "pointer",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Pay
                                                </button>
                                            </div>

                                            {expandedCard === index && (
                                                <div
                                                    style={{
                                                        marginTop: "10px",
                                                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                        padding: "10px",
                                                        borderRadius: "8px",
                                                        color: "#fff",
                                                    }}
                                                >
                                                    <p>
                                                        <strong>Coupon Code:</strong> {post.couponCode}
                                                    </p>
                                                    <p>
                                                        <strong>Valid From:</strong>{" "}
                                                        {new Date(post.startDate).toLocaleDateString()}
                                                    </p>
                                                    <p>
                                                        <strong>Valid Until:</strong>{" "}
                                                        {new Date(post.endDate).toLocaleDateString()}
                                                    </p>
                                                    <p>
                                                        <strong>Discount:</strong> {post.discountPercentage}%
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                            </div>
                        </div>


                        {/* Support Ticket */}
                        <div
                            style={{
                                position: "fixed",
                                bottom: "0px",
                                right: "30px",
                                width: "303px",
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                                borderRadius: "10px",
                                overflow: "hidden",
                                transition: "height 0.3s ease-in-out",
                                height: isOpen ? "400px" : "50px",
                                zIndex: 9999,
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "#b15cd6",
                                    color: "#fff",
                                    padding: "10px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    cursor: "pointer",
                                }}
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <FaCommentAlt style={{ marginLeft: "10px" }} />
                                <span style={{ flexGrow: 1, textAlign: "center" }}>Support</span>
                                {isOpen ? (
                                    <FaChevronDown style={{ marginRight: "10px" }} />
                                ) : (
                                    <FaChevronUp style={{ marginRight: "10px" }} />
                                )}
                            </div>

                            {isOpen && (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flex: 1,
                                        overflowY: "auto",
                                        padding: "10px",
                                        height: "352px",
                                        scrollbarWidth: "none",
                                    }}
                                >
                                    <h4 style={{ textAlign: "center", marginBottom: "10px" }}>
                                        Raise a Ticket
                                    </h4>

                                    <label style={{ fontWeight: "bold" }}>Ticket Type</label>
                                    <select
                                        value={ticketType}
                                        onChange={(e) => setTicketType(e.target.value)}
                                        style={{
                                            marginBottom: "10px",
                                            padding: "8px",
                                            borderRadius: "5px",
                                            border: "1px solid #ccc",
                                            outline: "none",
                                        }}
                                    >
                                        <option value="">Select Ticket Type</option>
                                        <option value="PAYOUT_ISSUE">Payout Issue</option>
                                        <option value="SUBSCRIPTION_ISSUE">Subscription Issue</option>
                                        <option value="ORDER_COMPLAINT">Order Complaint</option>
                                        <option value="TECHNICAL_SUPPORT">Technical Support</option>
                                        <option value="OTHER">Other</option>
                                    </select>

                                    <label style={{ fontWeight: "bold" }}>Message</label>
                                    <input
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        placeholder="Type your Issue here..."
                                        rows={3}
                                        style={{
                                            marginBottom: "10px",
                                            padding: "8px",
                                            borderRadius: "5px",
                                            border: "1px solid #ccc",
                                            height: "50px",
                                        }}
                                    />

                                    <label style={{ fontWeight: "bold" }}>Attachment</label>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        style={{ marginBottom: "10px" }}
                                    />

                                    <button
                                        onClick={handleSendTicket}
                                        style={{
                                            padding: "10px",
                                            backgroundColor: "#b15cd6",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "5px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Send Ticket
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cateringascrolling;
